import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroPagamentos } from '@/features/relatorio/page/financeiro/pagamentos/RelatorioFinanceiroPagamentos';

export const Route = createFileRoute('/a/relatorio/financeiro/pagamentos')({
    component: RelatorioFinanceiroPagamentos,
});
